import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "router-vertical-tabs" }

import { computed, provide } from "vue";
import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'router-vertical-tabs',
  emits: ["update:modelValue"],
  setup(__props, { emit }) {



const router = useRouter();
const routeFullPath = computed(() => router.currentRoute.value.fullPath);

provide("injectRouterVerticalTab", (data: string) => {
  router.push({ path: data });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default", { currentTab: routeFullPath.value })
  ]))
}
}

})